import React from "react";
import "./Accounts.css";
import SignUpForm from "./SingIn/SignIn";

const Accounts = () => {
  return (
    <div className="Accounts-container">
      <div className="Intro">
        <h1>🤓 Accounts Center Management :</h1>
        <p>
          <b>Instructions : </b>
          As having an account in MathTounsi requires filling a form, students'
          account has to be crafted before hand then handed to them. Also as
          monitors we encourage good behaviour and decipline, so you are able to
          put accounts in time out or upgrade one's status (If you are an Admin
          of course).
        </p>
      </div>
      <div className="AddUser">
        <div className="AddUser-discription">
            <h1>Instructions :</h1>
            <hr />
            <p>To not cause much trouble, we encourage copy pasting data from the google form to keep the content as accurate as possible.
                <br />If you are wondering where is the password field, well for the sake of security we are generating passwords for users on our own.
                <br />If you have any questions please report to the Admins for assistance.
                <br />This is a responsibility because we don't want people distrubting the educational flow of other or the websites purpose. So choose wisely before publishing the account. 
            </p>
            <div className="NB-box">
                <p>If you ever wonder where to consult user's application form, you may access it through this <a href="">link</a> and request access.</p>
            </div>
        </div>
        <SignUpForm/>
        
      </div>
    </div>
  );
};

export default Accounts;
